import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calculator from "@/components/Calculator";
import PaymentResult from "@/components/PaymentResult";
import LandingPage from "@/components/LandingPage";
import AdminDashboard from "@/components/AdminDashboard";
import StrategicStudy from "@/components/StrategicStudy";
import AuthCallback from "@/components/AuthCallback";
import Profile from "@/components/Profile";
import SectionPage from "@/components/SectionPage";
import MarketObservatory from "@/components/MarketObservatory";
import LegalPage from "@/components/LegalPage";
import { AuthProvider } from "@/context/AuthContext";
import { LANDING_SLUGS } from "@/data/landingPages";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/payment/success" element={<PaymentResult result="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult result="cancel" />} />
          <Route path="/pricing" element={<Calculator initialAnchor="pricing" />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/reviews" element={<AdminDashboard initialTab="reviews" />} />
          <Route path="/admin/users" element={<AdminDashboard initialTab="users" />} />
          <Route path="/admin/visits" element={<AdminDashboard initialTab="visits" />} />
          <Route path="/strategic-study" element={<StrategicStudy />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/me" element={<Profile />} />
          <Route path="/stories" element={<SectionPage section="stories" />} />
          <Route path="/about-calculator" element={<SectionPage section="about" />} />
          <Route path="/blog" element={<SectionPage section="blog" />} />
          <Route path="/guides" element={<SectionPage section="guides" />} />
          <Route path="/market" element={<MarketObservatory lang={localStorage.getItem("pl_lang") || "ar"} />} />
          <Route path="/services" element={<LegalPage page="services" />} />
          <Route path="/products" element={<LegalPage page="products" />} />
          <Route path="/terms" element={<LegalPage page="terms" />} />
          <Route path="/refund" element={<LegalPage page="refund" />} />
          <Route path="/privacy" element={<LegalPage page="privacy" />} />
          {LANDING_SLUGS.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<LandingPage />} />
          ))}
          <Route path="/" element={<Calculator />} />
          <Route path="*" element={<Calculator />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
